/**
 * Triage column id → backend comment anchor (OR-1534 / OR-1535).
 *
 * The backend anchors a thread to a dotted path into the `SubmissionList`
 * response (`COMMENT_FIELDS[SUBMISSION_TRIAGE]` in
 * `orion-backend/src/models/submission_comment.py`). Those keys are STORED
 * data — renaming one later needs a data migration — so this map is the
 * single place the frontend ties its column ids to them.
 *
 * Submission view only: the backend has no anchor for facility rows yet, so
 * the Facilities view renders without comments.
 *
 * Two columns have no anchor: Submission ID (`id`) and Hubspot Link
 * (`hubspot_id`) were dropped from `COMMENT_FIELDS` in the PR #407 review,
 * so those cells render without comments. Add them back here if the
 * backend restores them. (The free-text Notes column left the table
 * altogether; `note` was dropped from `COMMENT_FIELDS` too.)
 */
export const TRIAGE_COMMENT_FIELD: Readonly<Record<string, string>> = {
    // UW Information
    title: "title",
    renewal_date: "renewal_date",
    status: "status",
    brokerage: "brokerage",
    type: "type",
    submission_date: "submission_date",
    expiring_premium: "expiring_premium",
    expiring_deductible: "expiring_deductible",
    // Risk Management Contact
    rm_name: "contact.risk_manager_name",
    rm_phone: "contact.risk_manager_phone",
    rm_email: "contact.risk_manager_email",
    // Schedule
    facility_count: "schedule.num_facilities",
    skilled: "schedule.num_skilled_beds",
    assisted: "schedule.num_assisted_beds",
    independent: "schedule.num_independent_beds",
    additional_exposure: "schedule.num_additional_beds",
    retro_date: "schedule.pl_retro_date",
    // Premium Selection
    quoted_deductible: "quote.declared_sir",
    selected_premium: "quote.selected_premium",
    tria: "quote.tria_fee_amount",
    gemini_fees: "quote.tech_rm_fee",
    retail_commission: "quote.agent_commission_rate",
    tricura_fees: "quote.tricura_commission_rate",
    deviation: "quote.deviation_from_unity",
    probability: "probability_to_bind",
    uw: "assignee",
    approval_uw: "approver",
    policy_number: "policy.policy_number",
};

/** Cells that render a badge or a control rather than text: the commented
 *  state pads the yellow fill around them (Figma node 112-23397). */
export const TRIAGE_COMMENT_CONTROL_COLUMNS: ReadonlySet<string> = new Set(["status", "type"]);

